import * as React from 'react';

import {TextField} from 'shells/textfield/textfield';
import {Body} from 'shells/typography/body';

import styles from './add-merge-field.module.css';

type Props = {
    fallbackValue: string;
    setFallbackValue: (arg1: string) => void;
    placeholder?: string | null | undefined;
    label: string;
};

export function Fallback(props: Props) {
    return (
        <div className={styles['fallback-container']}>
            <div>
                <Body>Fallback text (optional)</Body>
            </div>
            <TextField
                value={props.fallbackValue}
                onChange={props.setFallbackValue}
                placeholder={props.placeholder || 'Your fallback text'}
                focusOnMount={true}
            />
            <span>
                If a recipient does not have a <b>{props.label}</b>, this fallback text will be
                used. If no fallback is provided, and if the recipient does not have a{' '}
                <b>{props.label}</b>, then they <b>will not</b> receive the email.
            </span>
        </div>
    );
}
